<template lang="html">
  <div class="slide">
    <svg ref="scene" class="canvas" :viewBox="`0 0 ${coverWidth} ${coverHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <rect x="0" y="0" :width="coverWidth" :height="coverHeight" />
      <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
        <picture>
          <source :srcset="`${publicPath}scenes/footprints/BG-480w.jpg`" media="(max-width: 480px)">
          <source :srcset="`${publicPath}scenes/footprints/BG-768w.jpg`" media="(max-width: 768px)">
          <source :srcset="`${publicPath}scenes/footprints/BG-1280w.jpg`" media="(max-width: 1280px)">
          <source :srcset="`${publicPath}scenes/footprints/BG-1920w.jpg`" media="(max-width: 1920px)">
          <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/footprints/BG.jpg`" />
        </picture>
      </foreignObject>
      <g ref="dino-feet" transform="translate(1158 188)">
        <ImageLazy
          width="1860" height="2354"
          :srcs="[
            `${publicPath}scenes/footprints/footprints3-q80-w500.png`,
            `${publicPath}scenes/footprints/footprints3.png`
          ]"/>
      </g>
      <g class="human-feet" clip-path="url(#clip-feet)">
        <ImageLazy
          width="3769" height="3006"
          :srcs="[
            `${publicPath}scenes/footprints/footprints4-q80-w1000.png`,
            `${publicPath}scenes/footprints/footprints4.png`
          ]"/>
      </g>
      <clipPath ref="clip-feet" id="clip-feet">
        <rect id="l-1" x="869.57" y="2811.52" width="365.74" height="192.17" style="fill: #0004ff"/>
        <rect id="l-2" x="807.58" y="2290.81" width="533.11" height="446.32" style="fill: #0004ff"/>
        <rect id="l-3" x="373.66" y="2129.64" width="412.36" height="412.36" style="fill: #0004ff"/>
        <rect id="l-4" x="237.28" y="1646.12" width="520.71" height="427.73" style="fill: #0004ff"/>
        <rect id="l-5" y="1447.76" width="175.29" height="412.23" style="fill: #0004ff"/>
        <rect id="l-6" x="45.12" y="530.32" width="632.29" height="564.1" style="fill: #0004ff"/>
        <rect id="l-7" x="324.07" y="71.6" width="483.52" height="402.93" style="fill: #0004ff"/>
        <rect id="l-8" x="931.56" y="0" width="545.5" height="384.33" style="fill: #0004ff"/>
        <rect id="r-1" x="3063.99" y="2513.97" width="272.75" height="489.71" style="fill: #0004ff"/>
        <rect id="r-2" x="3390.33" y="2073.85" width="322.34" height="514.51" style="fill: #0004ff"/>
        <rect id="r-3" x="3231.36" y="1646.12" width="320.14" height="396.73" style="fill: #0004ff"/>
        <rect id="r-4" x="3522.71" y="1131.61" width="266.55" height="514.51" style="fill: #0004ff"/>
        <rect id="r-5" x="3280.95" y="592.31" width="297.55" height="502.11" style="fill: #0004ff"/>
        <rect id="r-6" x="3522.71" y="121.19" width="266.55" height="471.12" style="fill: #0004ff"/>
        <rect id="r-7" x="3280.95" width="241.76" height="121.19" style="fill: #0004ff"/>
      </clipPath>
    </svg>
    <SceneDialogue
      ref="d1"
      :bg="`rgba(225,225,225,0.9)`"
      :width="0.2"
      :fontSize="20"
      :tx="0.7" :ty="0.2">
      He knew there were dinosaur bones and footprints out in Long Canyon.
    </SceneDialogue>
    <SceneDialogue
      ref="d2"
      :bg="`rgba(225,225,225,0.9)`"
      :width="0.2"
      :fontSize="20"
      :tx="0.27" :ty="0.6">
      So he led a group of paleontologists from the expedition there to show
      them.
    </SceneDialogue>
    <SceneDialogue
      ref="d3"
      :bg="`rgba(225,225,225,0.9)`"
      :width="0.4"
      :fontSize="24"
      :tx="0.53" :ty="0.9"
      :className="`minion text-center`"
      :styles="{padding: `1em 0.5em`}">
      The <b>“Segisaurus,”</b> as it came to be called.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/footprints/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  data: () => ({
    coverWidth: 4175,
    coverHeight: 3006,
    showContent: false,
  }),
  extends: Template,
  mounted() {
    const scene = this.$refs["scene"]
    const dino = this.$refs["dino-feet"]
    const d1 = this.$refs["d1"].$el
    const d2 = this.$refs["d2"].$el
    const d3 = this.$refs["d3"].$el
    const clipBoxes = Array.from(this.$refs["clip-feet"].querySelectorAll("#clip-feet rect"))
    TweenLite.set(scene, {opacity: 0})
    TweenLite.set(dino, {opacity: 0})
    TweenLite.set(d1, {opacity: 0})
    TweenLite.set(d2, {opacity: 0})
    TweenLite.set(d3, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(scene, 2, {opacity: 1}))
    this.tl.add(TweenLite.to(dino, 1, {opacity: 1}), "-=0.5")
    clipBoxes.forEach(b => {
      const i = parseInt(b.getAttribute("id").split("-")[1])
      TweenLite.set(b, {x: `-${this.coverWidth}.px`})
      this.tl.add(TweenLite.to(b, 0, {x: 0}), 2 + 0.1 * i)
    })
    this.tl.add(TweenLite.to(d1, 1, {opacity: 1}))
    this.tl.add(TweenLite.to(d2, 1, {opacity: 1}))
    this.tl.add(TweenLite.to(d3, 1, {opacity: 1}))
  },
  methods: {
    enter() {
      this.tl.play() }
  },
  props: ["slide"]
}
</script>
